/**
 * @file 学习资料页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Button} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import LearningPaddle from './components/learning-paddle/LearningPaddle';
import QuickOnhand from './components/quick-onhand/QuickOnhand';

const Learningmaterials: React.FC = () => {
    return (
        <div className="page paddle-lm-page">
            <Header />
            <Banner
                title="学习资料"
                subtitle="观看视频课程入门深度学习和飞桨，或尝试解决一些经典问题"
                divider
            />
            <div className="paddle-lm-page-container">
                <div className="paddle-context-h2">
                    学习Paddle
                </div>
                <LearningPaddle />

                <div className="paddle-context-h2">
                    快速上手
                </div>
                <QuickOnhand />

                <div className="paddle-context-h2">
                    基础知识
                </div>
                <div className="paddle-context-h3 paddle-lm-page-h3">
                    我们为您提供了系统化的AI学习路线和丰富的课程资源，帮助您从零掌握深度学习知识
                </div>
                <div className="paddle-lm-page-btn-group">
                    <a
                        href="http://abcxueyuan.cloud.baidu.com/#/line_course?nodeId=&index=&pageNo=1&sortTag=2"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button
                            className="paddle-lm-page-btn"
                            type="primary"
                            size="large"
                        >
                            去学习
                        </Button>
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Learningmaterials;
